import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02e599e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer-list" }
const _hoisted_2 = { class: "customer-list__header" }
const _hoisted_3 = { class: "customer-list__header__title" }
const _hoisted_4 = { class: "customer-list__header__menu" }
const _hoisted_5 = { class: "customer-list__header__menu__search w-3/6" }
const _hoisted_6 = { class: "proposal-list__header__menu__buttons" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-plus" }, null, -1))
const _hoisted_8 = { class: "customer-list__content" }
const _hoisted_9 = {
  key: 1,
  class: "bg-white rounded p-5 text-center"
}
const _hoisted_10 = {
  key: 2,
  class: "customer-list__content__table w-full"
}
const _hoisted_11 = { class: "customer-list__content__table__header customer-list__content__table__header--customer-id" }
const _hoisted_12 = { class: "customer-list__content__table__header customer-list__content__table__header--name" }
const _hoisted_13 = { class: "customer-list__content__table__header customer-list__content__table__header--country" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "customer-list__content__table__header customer-list__content__table__header--actions" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_input = _resolveComponent("search-input")!
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_customer_row = _resolveComponent("customer-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('customer.list.header.title')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_search_input, {
            modelValue: _ctx.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            "debounce-time": 0
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: {name: 'customers.create'} }, {
            default: _withCtx(() => [
              _createVNode(_component_outline_button, null, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('customer.list.header.menu.add')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.isCustomersProcessing)
        ? (_openBlock(), _createBlock(_component_content_loader, {
            key: 0,
            label: "general.loading"
          }))
        : _createCommentVNode("", true),
      (!_ctx.filteredCustomers.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, " There are no customers "))
        : _createCommentVNode("", true),
      (_ctx.filteredCustomers.length)
        ? (_openBlock(), _createElementBlock("table", _hoisted_10, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('customer.list.content.table.header.customer_id')) + " ", 1),
              _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('customer.list.content.table.header.name')) + " ", 1),
              _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('customer.list.content.table.header.country')) + " ", 1),
              _hoisted_14
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCustomers, (customer) => {
              return (_openBlock(), _createBlock(_component_customer_row, {
                key: customer.id,
                customer: customer
              }, null, 8, ["customer"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}